const blogPosts = [
    {
      id: 'web3-guides',
      title: "Web3 Development Guides",
      date: "2024-10-01",
      category: "Guides",
      excerpt: "Every technical web3 guide i've written...",
      markdownFile: 'web3-guides.md'
    }
    // Add more blog posts here
  ];
  
  export const getBlogById = (id) => {
    if (!id) return null;
    return blogPosts.find(post => post.id === id);
  };
  
  export { blogPosts };